/* =====================================================================
   Koforto 组件库（kf-x）· 公共脚本
   每个功能都是独立的自定义元素，页面上没有就不运行；重复加载只初始化一次。
   ===================================================================== */
(() => {
  if (window.__kfx) return; window.__kfx = true;
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const define = (n, c) => { if (!customElements.get(n)) customElements.define(n, c); };
  const money = (cents, fmt) => {
    fmt = fmt || (window.Shopify && window.Shopify.money_format) || window.kfxMoneyFormat || '{{amount}}';
    const d = (n, p, t = ',', dec = '.') => { const parts = (n / 100).toFixed(p).split('.'); return parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + t) + (parts[1] ? dec + parts[1] : ''); };
    const m = fmt.match(/\{\{\s*(\w+)\s*\}\}/); if (!m) return (cents / 100).toFixed(2);
    const v = { amount_no_decimals: () => d(cents, 0), amount_with_comma_separator: () => d(cents, 2, '.', ','), amount_no_decimals_with_comma_separator: () => d(cents, 0, '.', ','), amount_with_apostrophe_separator: () => d(cents, 2, "'", '.') }[m[1]];
    return fmt.replace(m[0], v ? v() : d(cents, 2));
  };
  window.kfxMoney = money;

  /* ---------- 横向滑动：箭头 / 圆点 / 自动播放 ---------- */
  define('kfx-slider', class extends HTMLElement {
    connectedCallback() {
      if (this._ok) return; this._ok = true;
      this.track = $('.kfx-track', this); if (!this.track) return;
      this.prev = $('.kfx-arrow--prev', this); this.next = $('.kfx-arrow--next', this); this.dots = $('.kfx-dots', this);
      const step = (dir) => { const it = this.track.children[0]; const w = it ? it.getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).columnGap || 0) : this.track.clientWidth; this.track.scrollBy({ left: dir * w, behavior: 'smooth' }); };
      this.prev && this.prev.addEventListener('click', () => step(-1));
      this.next && this.next.addEventListener('click', () => step(1));
      this.track.addEventListener('scroll', () => { cancelAnimationFrame(this._r); this._r = requestAnimationFrame(() => this.paint()); }, { passive: true });
      window.addEventListener('resize', () => this.build());
      this.build();
      const ap = +this.dataset.autoplay || 0;
      if (ap > 0) { let pause = false; this.addEventListener('mouseenter', () => pause = true); this.addEventListener('mouseleave', () => pause = false); this.addEventListener('touchstart', () => pause = true, { passive: true });
        setInterval(() => { if (pause || document.hidden) return; const max = this.track.scrollWidth - this.track.clientWidth - 2; if (this.track.scrollLeft >= max) this.track.scrollTo({ left: 0, behavior: 'smooth' }); else step(1); }, ap * 1000); }
    }
    pages() { const it = this.track.children[0]; if (!it) return 1; const per = Math.max(1, Math.round(this.track.clientWidth / (it.getBoundingClientRect().width || 1))); return Math.max(1, this.track.children.length - per + 1); }
    build() {
      const n = this.pages(); const nav = $('.kfx-nav', this); if (nav) nav.hidden = n < 2;
      if (this.dots) { this.dots.innerHTML = Array.from({ length: n }, (_, i) => `<button type="button" aria-label="${i + 1}"></button>`).join(''); [...this.dots.children].forEach((b, i) => b.addEventListener('click', () => { const it = this.track.children[i]; it && this.track.scrollTo({ left: it.offsetLeft - this.track.offsetLeft, behavior: 'smooth' }); })); }
      this.paint();
    }
    paint() {
      const t = this.track, max = t.scrollWidth - t.clientWidth - 2;
      if (this.prev) this.prev.disabled = t.scrollLeft <= 2 && !this.dataset.loop;
      if (this.next) this.next.disabled = t.scrollLeft >= max && !this.dataset.loop;
      if (this.dots) { const it = t.children[0]; const w = it ? it.getBoundingClientRect().width + parseFloat(getComputedStyle(t).columnGap || 0) : 1; const i = Math.round(t.scrollLeft / w); [...this.dots.children].forEach((d, k) => d.setAttribute('aria-current', k === Math.min(i, this.dots.children.length - 1))); }
    }
  });

  /* ---------- 倒计时：固定截止时间 / 每天到点 / 结束后重来（后两种默认关闭） ---------- */
  define('kfx-countdown', class extends HTMLElement {
    connectedCallback() {
      if (this._ok) return; this._ok = true;
      const ds = this.dataset, mode = ds.end || 'hide';
      const parse = (s) => { if (!s) return NaN; let iso = s.trim().replace(' ', 'T'); if (ds.tz === 'fixed' && ds.offset && !/[zZ]|[+-]\d\d:?\d\d$/.test(iso)) iso += ds.offset; return Date.parse(iso); };
      let target = parse(ds.time);
      if (mode === 'next_day' && !isNaN(target)) { const t = new Date(target), now = new Date(); const d = new Date(now); d.setHours(t.getHours(), t.getMinutes(), t.getSeconds(), 0); if (d <= now) d.setDate(d.getDate() + 1); target = d.getTime(); }
      if (mode === 'restart') { const key = 'kfx-cd-' + (ds.key || ds.time); const len = Math.max(60, (+ds.hours || 24) * 3600) * 1000; let st = +localStorage.getItem(key) || 0; const now = Date.now(); if (!st || st < now) { st = isNaN(target) || target < now ? now + len : target; try { localStorage.setItem(key, st); } catch (e) {} } target = st; this._len = len; this._key = key; }
      if (isNaN(target)) { (this.closest('[data-kfx-cd-host]') || this).hidden = true; return; }
      this.target = target; this.units = { d: $('[data-d]', this), h: $('[data-h]', this), m: $('[data-m]', this), s: $('[data-s]', this) };
      this.tick(); this._t = setInterval(() => this.tick(), 1000);
    }
    disconnectedCallback() { clearInterval(this._t); }
    tick() {
      let diff = this.target - Date.now();
      if (diff <= 0) {
        const mode = this.dataset.end || 'hide';
        if (mode === 'next_day') { this.target += 86400000; diff = this.target - Date.now(); }
        else if (mode === 'restart' && this._len) { this.target = Date.now() + this._len; try { localStorage.setItem(this._key, this.target); } catch (e) {} diff = this._len; }
        else { clearInterval(this._t); const host = this.closest('[data-kfx-cd-host]') || this; host.hidden = true; this.dispatchEvent(new CustomEvent('kfx:ended', { bubbles: true })); return; }
      }
      const showD = !!this.units.d; const s = Math.floor(diff / 1000);
      const d = Math.floor(s / 86400), h = showD ? Math.floor(s % 86400 / 3600) : Math.floor(s / 3600), m = Math.floor(s % 3600 / 60), sec = s % 60;
      const p = (n) => String(n).padStart(2, '0');
      if (this.units.d) this.units.d.textContent = p(d); if (this.units.h) this.units.h.textContent = p(h); if (this.units.m) this.units.m.textContent = p(m); if (this.units.s) this.units.s.textContent = p(sec);
    }
  });

  /* ---------- 标签页 ---------- */
  define('kfx-tabs', class extends HTMLElement {
    connectedCallback() {
      if (this._ok) return; this._ok = true;
      const btns = $$('.kfx-tabs__btn', this), panels = $$('.kfx-tabs__panel', this);
      const go = (i) => { btns.forEach((b, k) => b.setAttribute('aria-selected', k === i)); panels.forEach((p, k) => p.hidden = k !== i); };
      btns.forEach((b, i) => b.addEventListener('click', () => go(i))); go(0);
    }
  });

  /* ---------- 折叠行：手风琴（只开一个） ---------- */
  document.addEventListener('toggle', (e) => {
    const d = e.target; if (!(d instanceof HTMLDetailsElement) || !d.open) return;
    const g = d.closest('[data-kfx-single]'); if (!g) return;
    $$('details[open]', g).forEach((x) => { if (x !== d && x.closest('[data-kfx-single]') === g) x.open = false; });
  }, true);

  /* ---------- 弹窗：任意 [data-kfx-open="弹窗id"] 打开 ---------- */
  define('kfx-modal', class extends HTMLElement {
    connectedCallback() {
      if (this._ok) return; this._ok = true;
      if (this.parentElement !== document.body && this.dataset.portal !== 'no') document.body.appendChild(this);
      this.addEventListener('click', (e) => { if (e.target.closest('[data-kfx-close]') || e.target.classList.contains('kfx-modal__bg')) this.close(); });
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && this.hasAttribute('open')) this.close(); });
    }
    open() { this.setAttribute('open', ''); document.documentElement.style.overflow = 'hidden'; const f = $('.kfx-modal__close', this); f && f.focus(); this.dispatchEvent(new CustomEvent('kfx:open')); }
    close() { this.removeAttribute('open'); document.documentElement.style.overflow = ''; this.dispatchEvent(new CustomEvent('kfx:close')); }
  });
  document.addEventListener('click', (e) => {
    const t = e.target.closest('[data-kfx-open]'); if (!t) return;
    const m = document.getElementById(t.dataset.kfxOpen); if (m && m.open) { e.preventDefault(); m.open(); }
  });

  /* ---------- 复制折扣码 ---------- */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-kfx-copy]'); if (!b) return;
    const v = b.dataset.kfxCopy; const done = () => { const o = b.dataset.copied || 'Copied!'; const lbl = $('[data-copy-label]', b) || b; const old = lbl.textContent; lbl.textContent = o; b.classList.add('is-copied'); setTimeout(() => { lbl.textContent = old; b.classList.remove('is-copied'); }, 1800); };
    if (navigator.clipboard) navigator.clipboard.writeText(v).then(done, done); else { const i = document.createElement('input'); i.value = v; document.body.appendChild(i); i.select(); try { document.execCommand('copy'); } catch (x) {} i.remove(); done(); }
  });

  /* ---------- 点击领折扣：把折扣码写进结账（/discount/CODE），不跳页 ---------- */
  define('kfx-discount', class extends HTMLElement {
    connectedCallback() {
      if (this._ok) return; this._ok = true;
      const code = this.dataset.code; if (!code) return;
      const key = 'kfx-discount-' + code;
      const mark = () => { this.classList.add('is-applied'); const s = $('[data-applied]', this); const n = $('[data-not-applied]', this); if (s) s.hidden = false; if (n) n.hidden = true; };
      try { if (localStorage.getItem(key)) mark(); } catch (e) {}
      this.addEventListener('click', () => {
        if (this.classList.contains('is-applied')) return;
        fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin' }).finally(() => { try { localStorage.setItem(key, '1'); } catch (e) {} mark(); document.dispatchEvent(new CustomEvent('kfx:discount', { detail: { code } })); });
      });
    }
  });

  /* ---------- 预计送达 / 发货节点：按今天日期 + 天数，跳过指定星期和日期 ---------- */
  const addBiz = (start, days, skipW, skipD) => {
    const d = new Date(start); let n = 0; const iso = (x) => x.toISOString().slice(0, 10);
    const bad = (x) => skipW.includes(x.getDay()) || skipD.includes(iso(x)) || skipD.includes(iso(x).slice(5));
    while (n < days) { d.setDate(d.getDate() + 1); if (!bad(d)) n++; }
    return d;
  };
  const fmtDate = (d, f, dayNames, monNames) => {
    const dd = String(d.getDate()).padStart(2, '0'), mm = String(d.getMonth() + 1).padStart(2, '0');
    const day = dayNames[(d.getDay() + 6) % 7] || '', mon = monNames[d.getMonth()] || mm;
    switch (f) {
      case 'day_mm_dd': return `${day}, ${mon} ${d.getDate()}`;
      case 'day_dd_mm': return `${day}, ${d.getDate()} ${mon}`;
      case 'mm_dd': return `${mon} ${d.getDate()}`;
      case 'dd_mm': return `${d.getDate()} ${mon}`;
      case 'dd_mm_no_dot': return `${d.getDate()} ${mon}`.replace(/\./g, '');
      case 'day_dd_mm_numeric': return `${day}, ${dd}.${mm}`;
      case 'dd_mm_numeric': return `${dd}.${mm}`;
      default: return `${mon} ${d.getDate()}`;
    }
  };
  define('kfx-dates', class extends HTMLElement {
    connectedCallback() {
      if (this._ok) return; this._ok = true;
      const ds = this.dataset;
      const skipW = (ds.skipDays || '').split(',').map((x) => x.trim().toLowerCase()).filter(Boolean).map((x) => ({ sun: 0, mon: 1, tue: 2, wed: 3, thu: 4, fri: 5, sat: 6 })[x.slice(0, 3)]).filter((x) => x !== undefined);
      const skipD = (ds.skipDates || '').split(',').map((x) => x.trim()).filter(Boolean);
      const days = (ds.days || 'Mon,Tue,Wed,Thu,Fri,Sat,Sun').split(',').map((x) => x.trim());
      const mons = (ds.months || 'Jan,Feb,Mar,Apr,May,Jun,Jul,Aug,Sep,Oct,Nov,Dec').split(',').map((x) => x.trim());
      const now = new Date();
      $$('[data-kfx-date]', this).forEach((el) => {
        const [a, b] = el.dataset.kfxDate.split('-').map((x) => +x || 0);
        const t1 = fmtDate(addBiz(now, a, skipW, skipD), ds.format, days, mons);
        const t2 = b && b !== a ? fmtDate(addBiz(now, b, skipW, skipD), ds.format, days, mons) : '';
        if (el.dataset.part === 'start') el.textContent = t1; else if (el.dataset.part === 'end') el.textContent = t2 || t1; else el.textContent = t2 ? `${t1} – ${t2}` : t1;
      });
    }
  });

  /* ---------- 数字滚动（进入屏幕时从 0 滚到目标数） ---------- */
  define('kfx-count', class extends HTMLElement {
    connectedCallback() {
      if (this._ok) return; this._ok = true;
      const to = parseFloat(this.dataset.to || this.textContent) || 0, dec = (String(this.dataset.to).split('.')[1] || '').length, dur = +this.dataset.dur || 1200, delay = +this.dataset.delay || 0;
      const run = () => { const t0 = performance.now() + delay; const f = (t) => { const k = Math.min(1, Math.max(0, (t - t0) / dur)); const e = 1 - Math.pow(1 - k, 3); this.textContent = (to * e).toFixed(dec); if (k < 1) requestAnimationFrame(f); }; requestAnimationFrame(f); };
      if (!('IntersectionObserver' in window)) return;
      this.textContent = (0).toFixed(dec);
      const io = new IntersectionObserver((es) => es.forEach((e) => { if (e.isIntersecting) { run(); io.disconnect(); } }), { threshold: .4 }); io.observe(this);
    }
  });

  /* ---------- 前后对比滑块 ---------- */
  define('kfx-compare', class extends HTMLElement {
    connectedCallback() {
      if (this._ok) return; this._ok = true;
      const r = $('input[type=range]', this); if (!r) return;
      const set = () => this.style.setProperty('--kfx-pos', r.value + '%'); r.addEventListener('input', set); set();
    }
  });

  /* ---------- 热点：点开说明，同时只开一个 ---------- */
  define('kfx-hotspots', class extends HTMLElement {
    connectedCallback() {
      if (this._ok) return; this._ok = true;
      const pins = $$('[data-pin]', this);
      pins.forEach((p) => p.addEventListener('click', (e) => { e.stopPropagation(); const on = !p.classList.contains('is-open'); pins.forEach((x) => x.classList.remove('is-open')); p.classList.toggle('is-open', on); const i = p.dataset.pin; $$('[data-pin-item]', this).forEach((x) => x.classList.toggle('is-active', on && x.dataset.pinItem === i)); }));
      document.addEventListener('click', () => pins.forEach((x) => x.classList.remove('is-open')));
      $$('[data-pin-item]', this).forEach((x) => x.addEventListener('mouseenter', () => { const p = pins.find((y) => y.dataset.pin === x.dataset.pinItem); pins.forEach((y) => y.classList.toggle('is-open', y === p)); }));
    }
  });

  /* ---------- 时间线：点击切换内容（可自动播放） ---------- */
  define('kfx-timeline', class extends HTMLElement {
    connectedCallback() {
      if (this._ok) return; this._ok = true;
      const items = $$('[data-tl]', this), panels = $$('[data-tl-panel]', this);
      const go = (i) => { this.i = i; items.forEach((x, k) => { x.classList.toggle('is-active', k === i); x.classList.toggle('is-done', k < i); }); panels.forEach((p, k) => p.hidden = k !== i); this.style.setProperty('--kfx-tl', items.length > 1 ? (i / (items.length - 1)) * 100 + '%' : '100%'); };
      items.forEach((x, k) => x.addEventListener('click', () => go(k)));
      go(Math.min(+this.dataset.start || 0, items.length - 1));
      const ap = +this.dataset.autoplay || 0;
      if (ap > 0 && items.length > 1) setInterval(() => { if (!document.hidden && !this.matches(':hover')) go((this.i + 1) % items.length); }, ap * 1000);
    }
  });

  /* ---------- 公告栏：滑动 / 淡入淡出 自动切换 ---------- */
  /* ---------- 公告栏（Shrine：每行 N 条；手机 / 电脑可分别开轮播；滑动 / 循环 / 淡入淡出；可自动播放；顶部固定） ---------- */
  define('kfx-announce', class extends HTMLElement {
    connectedCallback() {
      if (this._ok) return; this._ok = true;
      const track = $('.kfx-ann__track', this); if (!track) return;
      const ds = this.dataset, type = ds.type || 'loop', ap = +ds.autoplay || 0;
      const active = () => (matchMedia('(min-width: 750px)').matches ? ds.slideD === '1' : ds.slideM === '1');
      let i = 0;
      const items = () => [...track.children].filter((x) => x.offsetParent !== null || type === 'fade');
      const per = () => { const it = track.children[0]; if (!it) return 1; return Math.max(1, Math.round(track.clientWidth / (it.getBoundingClientRect().width || track.clientWidth))); };
      const go = (k) => {
        const list = [...track.children]; if (!list.length) return;
        if (type === 'fade') { i = (k + list.length) % list.length; list.forEach((s, n) => s.classList.toggle('is-active', n === i)); return; }
        const max = Math.max(0, list.length - per());
        if (k > max) k = type === 'loop' ? 0 : max; if (k < 0) k = type === 'loop' ? max : 0;
        i = k; const it = list[i]; track.scrollTo({ left: it.offsetLeft - track.offsetLeft, behavior: 'smooth' });
      };
      const setup = () => { this.classList.toggle('is-slider', active()); if (type === 'fade') go(i); };
      setup(); addEventListener('resize', setup);
      if (ap > 0) setInterval(() => { if (!active() || document.hidden || this.matches(':hover')) return; const list = [...track.children]; if (type === 'slide' && i >= list.length - per()) return; go(i + 1); }, ap * 1000);
      track.addEventListener('scroll', () => { if (type === 'fade') return; const it = track.children[0]; if (it) i = Math.round(track.scrollLeft / (it.getBoundingClientRect().width || 1)); }, { passive: true });
      const wrap = this.closest('[data-kfx-ann-wrap]');
      if (wrap && ds.sticky === 'on-scroll-up') { let last = scrollY; addEventListener('scroll', () => { const y = scrollY; wrap.classList.toggle('is-hidden', y > last && y > wrap.offsetHeight + 40); last = y; }, { passive: true }); }
    }
  });
  define('kfx-promo', class extends HTMLElement {
    connectedCallback() {
      if (this._ok) return; this._ok = true;
      const ds = this.dataset, mode = ds.mode || 'disabled'; const modal = $('kfx-modal', this) || this.querySelector('kfx-modal');
      if (!modal || mode === 'disabled') return;
      const key = 'kfx-promo-' + (ds.key || 'x');
      if (mode === 'enabled') { try { const last = +localStorage.getItem(key) || 0; if (last && Date.now() - last < (+ds.days || 30) * 86400000) return; } catch (e) {} }
      if (mode === 'success_testing') { const s = $('[data-promo-success]', modal); const f = $('[data-promo-form]', modal); if (s) s.hidden = false; if (f) f.hidden = true; }
      const timer = $('[data-kfx-promo-timer]', modal);
      const runTimer = () => { if (!timer || timer._on) return; timer._on = true; let left = Math.max(1, +timer.dataset.min || 3) * 60; const b = $('b', timer); const p = (n) => String(n).padStart(2, '0'); const t = () => { b.textContent = p(Math.floor(left / 60)) + ':' + p(left % 60); if (left > 0) left -= 1; }; t(); setInterval(t, 1000); };
      let shown = false; const show = () => { if (shown) return; shown = true; modal.open(); runTimer(); try { localStorage.setItem(key, Date.now()); } catch (e) {} };
      const delay = (+ds.delay || 0) * 1000;
      if (ds.trigger === 'exit') { document.addEventListener('mouseout', (e) => { if (!e.relatedTarget && e.clientY < 10) show(); }); setTimeout(show, Math.max(delay, 30000)); }
      else if (ds.trigger === 'scroll') { addEventListener('scroll', () => { const p = scrollY / Math.max(1, document.body.scrollHeight - innerHeight); if (p * 100 >= (+ds.scroll || 40)) show(); }, { passive: true }); }
      else setTimeout(show, mode === 'testing' || mode === 'success_testing' ? 300 : delay);
      if (location.search.includes('customer_posted=true') || location.hash.includes('contact_form')) { const s = $('[data-promo-success]', modal); const f = $('[data-promo-form]', modal); if (s && f && document.querySelector('.kfx-promo .form-status')) { s.hidden = false; f.hidden = true; show(); } }
    }
  });

  /* ---------- 吸底购买条 / 回到顶部：滚过指定元素后出现 ---------- */
  define('kfx-sticky', class extends HTMLElement {
    connectedCallback() {
      if (this._ok) return; this._ok = true;
      const watch = this.dataset.watch ? document.querySelector(this.dataset.watch) : null; const hideAt = this.dataset.hideAt ? $$(this.dataset.hideAt) : [];
      const offset = this.dataset.offset !== undefined && this.dataset.offset !== '' ? +this.dataset.offset : 600;
      const upd = () => {
        const pct = this.dataset.percent !== undefined && this.dataset.percent !== '' ? +this.dataset.percent : null;
        let show = watch ? watch.getBoundingClientRect().bottom < 0 : pct !== null ? (scrollY / Math.max(1, document.documentElement.scrollHeight - innerHeight)) * 100 >= pct : scrollY > offset;
        if (show && hideAt.length) show = !hideAt.some((el) => { const r = el.getBoundingClientRect(); return r.top < innerHeight && r.bottom > 0; });
        if (this.dataset.upOnly && this._y !== undefined && scrollY > this._y) show = false; this._y = scrollY;
        this.classList.toggle('is-visible', show);
      };
      addEventListener('scroll', upd, { passive: true }); upd();
      $$('[data-kfx-top]', this).forEach((b) => b.addEventListener('click', () => scrollTo({ top: 0, behavior: 'smooth' })));
      $$('[data-kfx-scrollto]', this).forEach((b) => b.addEventListener('click', (e) => { const t = document.querySelector(b.dataset.kfxScrollto); if (t) { e.preventDefault(); t.scrollIntoView({ behavior: 'smooth', block: 'start' }); } }));
    }
  });

  /* ---------- 页面内平滑滚动按钮（如「跳到购买区」） ---------- */
  document.addEventListener('click', (e) => {
    const a = e.target.closest('a[href^="#"].kfx-jump, [data-kfx-jump]'); if (!a) return;
    const sel = a.dataset.kfxJump || a.getAttribute('href'); if (!sel || sel === '#') return;
    const t = document.querySelector(sel) || document.querySelector('[data-kfx-buy]') || document.querySelector('product-info, .product__info-wrapper');
    if (t) { e.preventDefault(); t.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
  });

  /* ---------- 加入购物车（通用按钮）：data-kfx-add='[{"id":123,"quantity":1}]' ---------- */
  window.kfxAddToCart = async (items, opts = {}) => {
    const drawer = document.querySelector('cart-drawer');
    const body = { items };
    if (drawer && drawer.getSectionsToRender) { body.sections = drawer.getSectionsToRender().map((s) => s.id); body.sections_url = window.location.pathname; }
    const r = await fetch((window.routes && window.routes.cart_add_url || '/cart/add') + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
    const data = await r.json();
    if (!r.ok || data.status) throw new Error(data.description || data.message || 'Error');
    if (opts.checkout) { window.location.href = (opts.discount ? '/discount/' + encodeURIComponent(opts.discount) + '?redirect=/checkout' : '/checkout'); return data; }
    if (drawer && drawer.renderContents && data.sections) { drawer.classList.remove('is-empty'); drawer.renderContents(data); }
    else if (!opts.stay) window.location.href = '/cart';
    document.dispatchEvent(new CustomEvent('kfx:cart-updated', { detail: data }));
    return data;
  };
  document.addEventListener('click', async (e) => {
    const b = e.target.closest('[data-kfx-add]'); if (!b || b.disabled) return;
    e.preventDefault(); let items; try { items = JSON.parse(b.dataset.kfxAdd); } catch (x) { return; }
    b.classList.add('is-loading'); b.disabled = true;
    try { await window.kfxAddToCart(items, { checkout: b.dataset.checkout === 'true', discount: b.dataset.discount }); }
    catch (err) { const m = b.parentElement.querySelector('[data-kfx-err]'); if (m) { m.textContent = err.message; m.hidden = false; } }
    finally { b.classList.remove('is-loading'); b.disabled = false; }
  });

  /* ---------- 视频：进屏静音自动播放 / 点击播放 ---------- */
  define('kfx-video', class extends HTMLElement {
    connectedCallback() {
      if (this._ok) return; this._ok = true;
      const v = $('video', this); if (!v) return;
      if (this.dataset.autoplay === 'true' && 'IntersectionObserver' in window) { v.muted = true; v.playsInline = true; const io = new IntersectionObserver((es) => es.forEach((e) => { if (e.isIntersecting) v.play().catch(() => {}); else v.pause(); }), { threshold: .3 }); io.observe(this); }
      const btn = $('.kfx-video__play', this); if (btn) btn.addEventListener('click', () => { v.muted = false; v.controls = true; v.play(); btn.hidden = true; });
      const snd = $('.kfx-video__sound', this); if (snd) snd.addEventListener('click', () => { v.muted = !v.muted; snd.classList.toggle('is-on', !v.muted); });
    }
  });

  /* ---------- 两分区并排：把两个分区移进来（Shrine section-group 逻辑） ---------- */
  define('kfx-group', class extends HTMLElement {
    connectedCallback() {
      if (this._ok) return; this._ok = true;
      const find = (id) => { if (!id) return null; return document.getElementById('shopify-section-' + id) || document.querySelector('[id^="shopify-section-"][id$="__' + id + '"]') || document.getElementById(id) || (document.getElementById('kfx-' + id) || {}).parentElement || null; };
      const put = (id, box) => { const el = find(id); if (el && box && el !== this.closest('.shopify-section')) box.appendChild(el); };
      const run = () => { put(this.dataset.one, $('.kfx-group__one', this)); put(this.dataset.two, $('.kfx-group__two', this)); };
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
    }
  });

  /* ---------- 订单查询（17TRACK 外部查询，与原主题一致） ---------- */
  define('kfx-track-order', class extends HTMLElement {
    connectedCallback() {
      if (this._ok) return; this._ok = true;
      const input = $('[data-kfx-track-input]', this), btn = $('[data-kfx-track-btn]', this), err = $('[data-kfx-track-err]', this), out = $('[data-kfx-track-result]', this);
      const load = (cb) => { if (window.YQV5) return cb(); const sc = document.createElement('script'); sc.src = 'https://www.17track.net/externalcall.js'; sc.onload = cb; document.head.appendChild(sc); };
      const go = () => { const num = (input.value || '').trim(); if (!num) { err.textContent = this.dataset.err || ''; err.hidden = false; return; } err.hidden = true; load(() => { try { window.YQV5.trackSingle({ YQ_ContainerId: out.id, YQ_Height: 560, YQ_Fc: '0', YQ_Lang: this.dataset.lang || 'en', YQ_Num: num }); } catch (e) { console.warn(e); } }); };
      btn.addEventListener('click', go); input.addEventListener('keydown', (e) => { if (e.key === 'Enter') { e.preventDefault(); go(); } });
    }
  });
})();
